<template>
  <div>
    <el-dialog
      title="来款确认分配"
      :visible.sync="dialogVisible"
      width="700px"
      top="15px"
      @open="open"
      @close="close"
    >
      <el-table :data="tableData" border style="width: 100%" show-summary
                :summary-method="getSummaries"
      >
        <el-table-column fixed type="index" width="50" label="序号" align="left" />
        <el-table-column prop="deliveryNum" label="分批申请单号" align="left" />
        <el-table-column prop="telegraphicTransferNum" label="电汇底单编号" align="left" />
        <el-table-column prop="amountSum" label="分批发货金额" align="right" header-align="left" width="160" />
        <el-table-column prop="assignAmount" label="本次分配金额" align="right" header-align="left" width="160" />
      </el-table>
      <div class="footer-btn">
        <el-button type="primary" :loading="loading" @click="submit">
          确认分配
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { assignPartialInvoiceByListTelegraphic, contractToAssignInfoListTransfer } from '@/API/index.js';
export default {
  data () {
    return {
      dialogVisible: this.dialogFormVisible,
      tableData: [],
      loading: false,
      sureData: {
        dialogData: [],
        contractType: '',
        contractId: 0
      }
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
  },
  methods: {
    initData () {
    },
    open () {
      this.tableData = this.data.dialogData;
      this.sureData = this.data;
    },
    close () {
      this.tableData = [];
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '本次分配金额') {
          sums[index] = this.AssignAmount();
        }
      });
      return sums;
    },
    AssignAmount () {
      let cont = 0;
      this.tableData.forEach((item) => {
        cont += item.assignAmount;
      });
      return cont;
    },
    // 确认分配按钮
    submit () {
      if (this.tableData.length === 0) {
        this.$message.error('请输入分配金额');
        return;
      }
      if (this.sureData.contractType != null && this.sureData.contractType.length === 6) {
        let assignInfoListVOList = [];
        this.sureData.dialogData.forEach((item) => {
          assignInfoListVOList.push({
            telegraphicTransferNum: item.telegraphicTransferNum,
            assignAmount: item.assignAmount,
            businessEntity: item.bussinessEntity
          });
        });
        let params = {
          id: this.sureData.contractId,
          assignInfoListVOList: assignInfoListVOList
        };
        this.loading = true;
        contractToAssignInfoListTransfer(params).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('分配成功');
            this.close();
            this.$router.go(-1);
            this.loading = false;
          } else {
            this.loading = false;
          }
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.tableData.forEach((item) => {
          item.assignAll = item.assignAmount;
          item.telegraphicNum = item.telegraphicTransferNum;
        });
        let event = {
          contractNum: this.sureData.contractNum,
          deliveryNum: this.tableData[0].deliveryNum,
          params: this.tableData
        };
        this.loading = true;
        assignPartialInvoiceByListTelegraphic(event).then((res) => {
          this.loading = false;
          let json = res.data;
          if (json.status === '200') {
            this.$message.success('分配成功');
            this.close();
            this.$router.go(-1);
          } else {
            this.loading = false;
          }
        }).catch((res) => {
          this.loading = false;
        });
      }
    }
  },
  mounted () {
    // this.initData();
  },
  watch: {
    dialogFormVisible (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  }

};
</script>

<style scoped>
.footer-btn{
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
